export const REGISTRATION = 'action_REGISTRATION';
export const LOGIN = 'action_LOGIN';
export const SIGNUP_VERIF = 'action_SIGNUP_VERIF';
export const OTP_VERIF = 'action_OTP_VERIF';
export const RESEND_OTP = 'action_RESEND_OTP';
export const FORGOT_PASS = 'action_FORGOT_PASS';
export const CREATE_NEW_PASS = 'action_CREATE_NEW_PASS';

export const CREATE_SUBSCRIPTION = 'action_CREATE_SUBSCRIPTION';
export const GET_SUBSCRIPTIONS = 'action_GET_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTIONS = 'action_UPDATE_SUBSCRIPTION';

export const GET_USER_DATA = 'action_GET_USER_DATA';
export const GET_WALLET = 'action_GET_WALLET';
export const SET_PIN = 'action_SET_PIN';
export const GET_WALLET_DETAILS = 'action_GET_WALLET_DETAILS';
export const UPDATE_USER_DATA = 'action_UPDATE_USER_DATA';
export const GET_ADDRESS = 'action_GET_ADDRESS';
export const UPDATE_ADDRESS = 'action_UPDATE_ADDRESS';
export const DELETE_ADDRESS = 'action_DELETE_ADDRESS';
export const ADD_ADDRESS = 'action_ADD_ADDRESS';

export const GET_CATEGORIES = 'action_GET_CATEGORIES';
export const GET_CONDITIONS = 'action_GET_CONDITIONS';

export const REQUEST_IN = 'action_REQUEST_IN';
export const UPDATE_REQUEST_IN = 'action_UPDATE_REQUEST_IN';
export const REQUEST_OUT = 'action_REQUEST_OUT';
export const REQUEST_ITEM = 'action_REQUEST_ITEM';
export const GET_REQUESTS = 'action_GET_REQUESTS';
export const GET_REQUEST_DETAILS = 'action_GET_REQUEST_DETAILS';
export const GET_REQUEST_HISTORY = 'action_GET_REQUEST_HISTORY';
export const GET_REQUEST_HISTORY_DETAILS = 'action_GET_REQUEST_HISTORY_DETAILS';
export const GET_COURIER = 'action_GET_COURIER';
export const GET_ADMIN = 'action_GET_ADMIN';
export const GET_ADMIN_DETAILS = 'action_GET_ADMIN_DETAILS';
export const GET_CUSTOMER = 'action_GET_CUSTOMER';
export const GET_CUSTOMER_DETAILS = 'action_GET_CUSTOMER_DETAILS';
export const CREATE_ADMIN = 'action_CREATE_ADMIN';
export const CREATE_CUSTOMER = 'action_CREATE_CUSTOMER';
export const UPDATE_ADMIN = 'action_UPDATE_ADMIN';
export const UPDATE_CUSTOMER = 'action_UPDATECUSTOMERN';
export const POST_COURIER = 'action_POST_COURIER';
export const DETAIL_COURIER = 'action_DETAIL_COURIER';
export const ASSIGN_COURIER = 'action_ASSIGN_COURIER';
export const VALIDATE_ITEMS = 'action_VALIDATE_ITEMS';
export const UPDATE_REQUEST = 'action_UPDATE_REQUEST';
export const DECLINE_REQUEST = 'action_DECLINE_REQUEST';
export const FINISH_REQUEST = 'action_FINISH_REQUEST';
export const ASSIGN_ITEMS_TO_BOX = 'action_ASSIGN_ITEMS_TO_BOX';
export const GET_TRANSACTIONS = 'action_GET_TRANSACTIONS';
export const GET_TRANSACTION_DETAILS = 'action_GET_TRANSACTION_DETAILS';
export const GET_REQUESTED_ITEMS = 'action_GET_REQUESTED_ITEMS';
export const GET_REQUESTED_ITEM_DETAILS = 'action_GET_REQUESTED_ITEM_DETAILS';
export const UPDATE_REQUESTED_ITEM_STATUS = 'action_UPDATE_REQUESTED_ITEM_STATUS';
export const GET_DASHBOARD_INFO = 'action_GET_DASHBOARD_INFO';
export const GET_DASHBOARD_OVERVIEW = 'action_GET_DASHBOARD_OVERVIEW';
export const GET_NOTIFICATIONS = 'action_GET_NOTIFICATIONS';

export const GET_BOX = 'action_GET_BOX';
export const GET_USER_ITEMS = 'action_GET_USER_ITEMS';
export const GET_USER_ITEM = 'action_GET_USER_ITEM_DETAILS';
export const GET_BOX_DETAILS = 'action_GET_BOX_DETAILS';
export const CREATE_NEW_STORAGES = 'action_CREATE_NEW_STORAGES';
export const DELETE_STORAGES = 'action_DELETE_STORAGES';
export const SET_BOX_COLUMN = 'action_SET_BOX_COLUMN';
export const RESET_BOX_COLUMN = 'action_RESET_BOX_COLUMN';

export const POST_ITEM_TO_MARKET = 'action_POST_ITEM_TO_MARKET';
export const GET_ITEM_FROM_MARKET = 'action_GET_ITEM_FROM_MARKET';
export const GET_MARKET_MY_BID = 'action_GET_MARKET_MY_BID';
export const GET_MARKET_WATCHLIST = 'action_GET_MARKET_WATCHLIST';
export const GET_MARKET_SALE_ITEM = 'action_GET_MARKET_SALE_ITEM';
export const GET_MARKET_MY_ORDERS = 'action_GET_MARKET_MY_ORDERS';
export const GET_MY_ITEM_FROM_MARKET = 'action_GET_MY_ITEM_FROM_MARKET';
export const GET_AUCTION_FROM_MARKET = 'action_GET_AUCTION_FROM_MARKET';
export const GET_FIXEDPRICE_FROM_MARKET = 'action_GET_FIXEDPRICE_FROM_MARKET';
export const GET_ITEM_DETAILS = 'action_GET_ITEM_DETAILS';
export const CHECKOUT_ITEM = 'action_CHECKOUT_ITEM';
export const SELL_ITEM = 'action_SELL_ITEM';
export const DELETE_FROM_CART = 'action_DELETE_FROM_CART';
export const ADD_TO_CART = 'action_ADD_TO_CART';
export const GET_CART = 'action_GET_CART';
export const DELIVERY_LIST = 'action_DELIVERY_LIST';
export const ADD_ONS = 'action_ADD_ONS';
export const CREATE_ADD_ONS = 'action_CREATE_ADD_ONS';
export const EDIT_ADD_ONS = 'action_EDIT_ADD_ONS';
export const DELETE_ADD_ONS = 'action_DELETE_ADD_ONS';
export const CHECKOUT_ADD_ON = 'action_CHECKOUT_ADD_ON';
export const ADD_TO_WATCHLIST = 'action_ADD_TO_WATCHLIST';
export const ADD_REMINDER = 'action_ADD_REMINDER';
export const LIST_WATCHLIST = 'action_LIST_WATCHLIST';
export const GET_REQ_STATUS = 'action_GET_REQ_STATUS';

export const CUSTOMER_ITEMS = 'action_CUSTOMER_ITEMS';
export const CUSTOMER_REQUESTS = 'action_CUSTOMER_REQUESTS';
export const CUSTOMER_SUBSCRIPTIONS = 'action_CUSTOMER_SUBSCRIPTIONS';
export const CUSTOMER_MARKET = 'action_CUSTOMER_MARKET';
export const CUSTOMER_WALLET = 'action_CUSTOMER_WALLET';

export const VOLUME_UNIT = 'action_VOLUME_UNIT';
export const TOGGLE_SUBSCRIBED = 'action_TOGGLE_SUBSCRIBED';
export const CANCEL_SELLING = 'action_CANCEL_SELLING';
export const NOTIFY_USER_BROKEN_ITEM = 'action_NOTIFY_USER_BROKEN_ITEM';
export const MOVE_STORAGE_SITE_LOCATION = 'action_MOVE_STORAGE_SITE_LOCATION';
